import { render } from "./PainelEtiquetas.vue?vue&type=template&id=6f2b39c9&scoped=true"
import script from "./PainelEtiquetas.vue?vue&type=script&lang=js"
export * from "./PainelEtiquetas.vue?vue&type=script&lang=js"

import "./PainelEtiquetas.vue?vue&type=style&index=0&id=6f2b39c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2b39c9"]])

export default __exports__